export const defaultMessages = {
    ADD_PROJECT_URL_ERROR:
        "URL is either invalid or user doesn't have the necessary permissions to access it",
    PROJECT_ALREADY_EXISTS: "Project already exists",
};
